import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerlogged';
import Solicitacao from '../../../components/user/solicitacao/listar/editar';


function EditSolicitacaoScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Solicitação | Departamento de TI" />
            <Header />
            <Solicitacao />
            <Footer />
        </Fragment>
    );
}

export default EditSolicitacaoScreen;